import { createAsyncThunk } from "@reduxjs/toolkit";
import { getPaymentPlans } from "../../services/utils/utils.service";

export const fetchPaymentPlans = createAsyncThunk(
  'app/fetchPaymentPlan',  
  async (_, thunkAPI) => {    
    try {
      const data = await getPaymentPlans();
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue('Error fetching payment plans');
    }
  }
);